import {Plus} from 'lucide-react';
import {ButtonSquare, Popper} from '../../components';
import {StepDividerMenu} from './StepDividerMenu';

interface CreateEmptyBlockRenderProps {
  onAddManual: () => void;
  onAddBrowser: () => void;
}

export const StepDivider = ({onAddManual, onAddBrowser}: CreateEmptyBlockRenderProps) => {
  return (
    <div className="flex items-center">
      <div className="h-px w-full bg-border-primary" />

      <Popper menu={<StepDividerMenu onAddManual={onAddManual} onAddBrowser={onAddBrowser} />}>
        <ButtonSquare className="shrink-0">
          <Plus className="size-6" />
        </ButtonSquare>
      </Popper>

      <div className="h-px w-full bg-border-primary" />
    </div>
  );
};
